import React, { Suspense } from 'react';

export interface SuspenseWrapperProps {
  fallback?: React.ReactNode;
}

const SuspenseWrapper: React.FC<
  React.PropsWithChildren<SuspenseWrapperProps>
> = ({ children, fallback = <div data-async-loading /> }) => (
  <Suspense fallback={fallback}>{children}</Suspense>
);

export default SuspenseWrapper;
